<template>
  <v-app>
    <router-view v-if="loading === false" />
  </v-app>
</template>

<script>
  import Vue from 'vue'
import storage from './utility/storage'
  export default {
    name: 'App',
    data() {
      return {
        loading: true
      }
    },
    created() {
      this.$http.interceptors.response.use(undefined, function (err) {
        return new Promise(function () {
          if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
            this.$store.dispatch('logout').then(() => {
              this.$router.push({ name: 'auth-login' })
            })
          }
          throw err
        })
      })
    }, 
    mounted() {
      storage.setString('is_undermaintenance', false)
      Vue.axios.get('/api/v1/bo/setting/all?filterByCode=system.maintenance').then((response) => {
        const app = response.data.data['system.maintenance'] !== null ? response.data.data['system.maintenance'].app : []
        if (app.length) {
          for (let i = 0; i < app.length; i++) {
            if (app[i].key === 'affiliate' && app[i].value == true) {
              storage.setString('is_undermaintenance', true)
              this.$router.push({ name: 'maintenance' })
            }
          }
        }

        this.loading = false
      })
    }
  }
</script>

<style>
  @import url("https://use.typekit.net/afy7ntn.css");

  body {
    font-family: proxima-nova, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
  }
  .v-application {
    font-family: proxima-nova, sans-serif !important;
    font-style: normal;
    font-weight: 400;
    line-height: 1.2 !important;
  }
  .row {
    margin: 0 -12px !important;
  }

  /* Font Size */
  .font-xs { font-size: 11px; }
  .font-sm { font-size: 12px; }
  .font-mnm { font-size: 13px; }
  .font-nm { font-size: 14px !important; }
  .font-md { font-size: 16px !important; }
  .font-lg { font-size: 18px; }
  .font-xl { font-size: 20px; }
  .font-xxl { font-size: 26px; }

  /* Font Attribute */
  .bold { font-weight: 700; }
  .semibold { font-weight: 600; }
  .italic { font-style: italic; }
  .underline { text-decoration: underline; }
  .uppercase { text-transform: uppercase; }

  /* Alignments */
  .left { text-align: left; }
  .center { text-align: center; }
  .right { text-align: right; }
  .flex-right { justify-content: flex-end; }
  .flex-middle { align-items: center; }

  /* Text Color */
  .black-text { color: #172530; }
  .white-text { color: #fff !important; }
  .gray-l-text { color: #b1c6d6; }
  .gray-text { color: #70889a; }
  .gray-d-text { color: #647079; }
  .yellow-text { color: #FBCC04; }
  .blue-text { color: #539AFB; }
  .l-blue-text { color: #89B8FA; }
  .green-text { color: #47CC95; }
  .red-text { color: #FF6060; }
  .bitcoin-text { color: #F7931A; }
  .usdttrc20-text { color: #C1272D; }
  .usdterc20-text { color: #627FEB; }

  /* Solid BG */
  .bg-black { background-color: #172530; }
  .bg-white { background-color: #fff !important; }
  .bg-gray-l { background-color: #EFEFF4; }
  .bg-gray { background-color: #DEDEDE; }
  .bg-gray-d { background-color: #70889a; }
  .bg-yellow { background-color: #FBCC04; }
  .bg-yellow-20 { background-color: rgba(251,204,4,0.20) }
  .bg-blue { background-color: #539AFB; }
  .bg-blue-20 { background-color: rgba(83,154,251,0.20) }
  .bg-green { background-color: #47CC95 !important; }
  .bg-green-20 { background-color: rgba(71,204,149,0.20) }
  .bg-red { background-color: #FF6060; }
  .bg-red-20 { background-color: rgba(255,96,96,0.20) }

  /* Gradient BG */
  .gradient-black { background: linear-gradient(to right, #172530, #344757) !important; }
  .gradient-yellow { background: linear-gradient(to right, #FBCC04, #FADA4B) !important; }
  .gradient-blue { background: linear-gradient(to right, #539AFB, #89B8FA) !important; }
  .gradient-green { background: linear-gradient(to right, #47CC95, #5CCC9D) !important; }
  .gradient-red { background: linear-gradient(to right, #FF6060, #FD7474) !important; }
  .gradient-usdttrc20 { background: linear-gradient(to right, #C1272D, #C13A44) !important; }
  .gradient-usdterc20 { background: linear-gradient(to right, #627FEB, #627FEB) !important; }
  .gradient-bitcoin { background: linear-gradient(to right, #F7931A, #F7A43F) !important; }
  .gradient-skrill { background: linear-gradient(to right, #862165, #AD4D8D) !important; }
  .gradient-neteller { background: linear-gradient(to right, #83BA3B, #99C65D) !important; }

  /* Border */
  .border-gray { border-left: 4px solid #DEDEDE; }
  .border-b-gray { border-bottom: 1px solid #DEDEDE; }
  .border-yellow { border-left: 4px solid #FBCC04; }
  .border-blue { border-left: 4px solid #539AFB !important; }
  .border-green { border-left: 4px solid #47CC95 !important; }
  .border-red { border-left: 4px solid #FF6060 !important; }

  /* Border */
  .chip-primary {
    color: #fff !important;
    background: linear-gradient(to right, #539AFB, #89B8FA) !important;
  }
  .chip-success {
    color: #fff !important;
    background: linear-gradient(to right, #47CC95, #5CCC9D) !important;
  }
  .chip-error {
    color: #fff !important;
    background: linear-gradient(to right, #FF6060, #FD7474) !important;
  }
  .chip-usdttrc20 {
    color: #fff !important;
    background: linear-gradient(to right, #C1272D, #C13A44) !important;
  }
  .chip-usdterc20 {
    color: #fff !important;
    background: linear-gradient(to right, #627FEB, #627FEB) !important;
  }
  .chip-bitcoin {
    color: #fff !important;
    background: linear-gradient(to right, #F7931A, #F7A43F) !important;
  }
  .chip-skrill {
    color: #fff !important;
    background: linear-gradient(to right, #862165, #AD4D8D) !important;
  }
  .chip-neteller {
    color: #fff !important;
    background: linear-gradient(to right, #83BA3B, #99C65D) !important;
  }

  /* Margin */
  .m-5 { margin: 5px; }
  .m-10 { margin: 10px; }
  .m-15 { margin: 15px; }
  .m-20 { margin: 20px; }
  .m-25 { margin: 25px; }
  .m-30 { margin: 30px; }
  .m-t-n5 { margin-top: -5px; }
  .m-t-0 { margin-top: 0 !important; }
  .m-t-3 { margin-top: 3px; }
  .m-t-5 { margin-top: 5px; }
  .m-t-8 { margin-top: 8px; }
  .m-t-10 { margin-top: 10px; }
  .m-t-15 { margin-top: 15px !important; }
  .m-t-20 { margin-top: 20px; }
  .m-t-25 { margin-top: 25px; }
  .m-t-30 { margin-top: 30px; }
  .m-t-40 { margin-top: 40px; }
  .m-t-50 { margin-top: 50px; }
  .m-t-140 { margin-top: 140px; }
  .m-r-0 { margin-right: 0 !important; }
  .m-r-5 { margin-right: 5px; }
  .m-r-10 { margin-right: 10px; }
  .m-r-15 { margin-right: 15px; }
  .m-r-20 { margin-right: 20px; }
  .m-r-25 { margin-right: 25px; }
  .m-r-30 { margin-right: 30px; }
  .m-b-3 { margin-bottom: 3px; }
  .m-b-5 { margin-bottom: 5px; }
  .m-b-10 { margin-bottom: 10px; }
  .m-b-15 { margin-bottom: 15px; }
  .m-b-20 { margin-bottom: 20px; }
  .m-b-25 { margin-bottom: 25px; }
  .m-b-30 { margin-bottom: 30px; }
  .m-b-40 { margin-bottom: 40px; }
  .m-b-50 { margin-bottom: 50px; }
  .m-l-5 { margin-left: 5px; }
  .m-l-10 { margin-left: 10px; }
  .m-l-15 { margin-left: 15px; }
  .m-l-20 { margin-left: 20px; }
  .m-l-25 { margin-left: 25px; }
  .m-l-30 { margin-left: 30px; }
  .m-lr-5 { margin-left: 5px; margin-right: 5px; }
  .m-lr-10 { margin-left: 10px; margin-right: 10px; }
  .m-lr-15 { margin-left: 15px; margin-right: 15px; }
  .m-lr-20 { margin-left: 20px; margin-right: 20px; }
  .m-lr-25 { margin-left: 25px; margin-right: 25px; }
  .m-lr-30 { margin-left: 30px; margin-right: 30px; }

  /* Padding */
  .p-5 { padding: 5px; }
  .p-10 { padding: 10px; }
  .p-15 { padding: 15px; }
  .p-20 { padding: 20px; }
  .p-25 { padding: 25px; }
  .p-30 { padding: 30px; }
  .p-t-5 { padding-top: 5px; }
  .p-t-10 { padding-top: 10px !important; }
  .p-t-15 { padding-top: 15px; }
  .p-t-20 { padding-top: 20px !important; }
  .p-t-25 { padding-top: 25px; }
  .p-t-30 { padding-top: 30px; }
  .p-t-40 { padding-top: 40px; }
  .p-t-50 { padding-top: 50px; }
  .p-r-5 { padding-right: 5px; }
  .p-r-10 { padding-right: 10px; }
  .p-r-15 { padding-right: 15px !important; }
  .p-r-20 { padding-right: 20px; }
  .p-r-25 { padding-right: 25px; }
  .p-r-30 { padding-right: 30px; }
  .p-b-0 { padding-bottom: 0 !important; }
  .p-b-5 { padding-bottom: 5px !important; }
  .p-b-10 { padding-bottom: 10px; }
  .p-b-15 { padding-bottom: 15px; }
  .p-b-20 { padding-bottom: 20px; }
  .p-b-25 { padding-bottom: 25px; }
  .p-b-30 { padding-bottom: 30px; }
  .p-b-70 { padding-bottom: 70px; }
  .p-l-5 { padding-left: 5px; }
  .p-l-10 { padding-left: 10px; }
  .p-l-15 { padding-left: 15px !important; }
  .p-l-20 { padding-left: 20px; }
  .p-l-25 { padding-left: 25px; }
  .p-l-30 { padding-left: 30px; }
  .p-lr-5 { padding-left: 5px; padding-right: 5px; }
  .p-lr-10 { padding-left: 10px; padding-right: 10px; }
  .p-lr-15 { padding-left: 15px; padding-right: 15px; }
  .p-lr-20 { padding-left: 20px; padding-right: 20px; }
  .p-lr-25 { padding-left: 25px; padding-right: 25px; }
  .p-lr-30 { padding-left: 30px; padding-right: 30px; }

  /* Width */
  .w-100 { width: 100%; }
  .w-80 { width: 80%; }
  .w-60 { width: 60%; }
  .w-50 { width: 50%; }
  .w-40 { width: 40%; }
  .w-20 { width: 20%; }
  .w-10 { width: 10%; }

  /* Opacity */
  .opacity-50 { opacity: 0.5; }

  /* Snackbar Customized General*/
  .v-snack {
    font-size: 12px !important;
    line-height: 1.5;
  }
  .v-snack__wrapper {
    background: linear-gradient(to right, #172530, #1c2d3b) !important;
  }

  /* Chip */
  .v-chip.v-size--default {
    font-size: 10px !important;
    height: auto !important;
  }
  .loading-wrapper {
    display: flex;
    height: 100vh;
    align-items: center;
    justify-content: center;
  }
  .login-bg {
    background-image: url(assets/login-bg.svg);
    background-position: 30% bottom;
    background-repeat: no-repeat;
    background-size: 230%;
  }
  .wb-container {
    background-image: url(assets/withdrawal-bg.svg);
    background-position: right bottom;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .header-bg-img {
    background-image: url(assets/login-bg.svg);
    background-position: center bottom;
    background-repeat: no-repeat;
    background-size: 150%;
  }
  .br-0 {
    border-radius: 0 !important;
  }
  .br-wrapper {
    border-radius: 10px 10px 0 0;
    margin-top: -15px;
  }
  .logo-wrapper {
    margin-left: auto;
    margin-right: auto;
  }
  .custom-card {
    border-radius: 5px;
  }
  .custom-card-shadow {
    border-radius: 5px;
    -webkit-box-shadow: 0px 0px 15px 0px rgba(23,37,48,0.10);
    -moz-box-shadow: 0px 0px 15px 0px rgba(23,37,48,0.10);
    box-shadow: 0px 0px 15px 0px rgba(23,37,48,0.10);
  }
  .flex-container {
    display: flex;
  }
  .flex-inline-container {
    display: inline-flex;
  }
  .container {
    padding: 15px !important;
  }
  .v-card {
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0), 0px 2px 2px 0px rgba(0, 0, 0, 0), 0px 1px 5px 0px rgba(0, 0, 0, 0) !important;
  }
  .v-application--wrap {
    background-color: #EFEFF4;
  }
  .no-line {
    text-decoration: none;
  }
  .divider {
    height: 1px;
    width: 100%;
  }
  .v-btn {
    font-size: 14px !important;
    font-weight: 400 !important;
    letter-spacing: 0.25px !important;
  }
  .v-btn-smb {
    font-size: 12px !important;
    font-weight: 700 !important;
  }
  .v-btn--contained {
    box-shadow: none !important;
  }
  .get-code-btn {
    height: 40px !important;
    min-width: auto !important;
    padding: 0 15px !important;
    font-size: 13px !important;
    text-transform: capitalize !important;
    font-weight: 600 !important;
    margin-left: 5px;
  }
  .request-btn {
    height: auto !important;
    min-width: auto !important;
    padding: 10px 15px !important;
    text-transform: capitalize !important;
    font-weight: 600 !important;
    color: #fff !important;
  }
  .ghost-btn {
    border: 1px solid #70889a;
  }
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  .piwiblue {
    background-color: #172530 !important;
  }

  .login-header h1 {
    font-size: 20px;
  }
  .login-logo {
    width: 32%;
  }
  .login-tab-wrapper {
    padding: 0 25px;
  }
  .login-tab-wrapper .v-tab {
    margin-left: 0 !important;
    text-transform: none;
  }
  .login-tab-wrapper a.v-tab {
    width: 50%;
  }
  .login-tab-wrapper .theme--dark.v-tabs .v-tabs-bar {
    background-color: #172530 !important;
  }
  .login-tab-wrapper .v-tabs-bar {
    height: 40px !important;
  }
  .login-tab-wrapper .v-label {
    font-size: 14px;
  }
  .login-tab-wrapper .v-tabs-slider-wrapper {
    height: 3px !important;
  }
  .login-form-wrapper .v-input__slot {
    padding: 0 10px !important;
  }
  .login-form-wrapper .v-text-field.v-text-field--solo .v-input__control {
    min-height: 38px !important;
  }
  .login-form-wrapper .v-messages__message {
    font-size: 10px;
    text-align: left;
  }
  .login-form-wrapper .v-text-field__details {
    padding: 0 !important;
  }
  .login-form-wrapper .v-icon.v-icon {
    color: #89B8FA;
  }
  .login-form-wrapper .v-text-field input {
    font-size: 14px;
  }
  .login-form-wrapper .v-input--selection-controls {
    margin-top: 0;
    padding-top: 0;
  }
  .login-form-wrapper .v-text-field__details {
    margin-bottom: 0 !important;
  }
  .login-form-wrapper .v-btn {
    letter-spacing: 0.25px;
  }
  .login-switch-wrapper .v-label {
    font-size: 12px;
  }
  .login-switch-wrapper .v-input__slot {
    padding: 0 !important;
    margin-bottom: 0 !important;
  }
  .theme--dark .v-label {
    color: rgba(255, 255, 255, 1) !important;
  }
  .login-phone .phone-select {
    border-radius: 5px 0 0 5px;
  }
  .login-phone .username-input {
    border-radius: 0 5px 5px 0;
  }
  .login-phone .username-input .v-input__icon {
    display: none;
  }
  .login-phone .username-input  .v-input__slot {
    padding: 0 10px 0 0 !important
  }
  .login-btn {
    text-transform: uppercase !important;
    font-weight: 600 !important;
  }
  .login-get-code {
    margin-top: -10px;
    font-weight: 600 !important;
  }
  .login-get-code .v-btn__content {
    text-transform: initial;
  }

  /* Dashboard */
  .balance-border {
    border-right: 1px solid #DEDEDE;
  }
  .balance-header-border {
    border-right: 1px solid rgba(255, 255, 255, 0.2);
  }
  .header-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .header-content-wrapper {
    display: flex;
    align-items: center;
  }
  .notification-icon {
    position: relative;
  }
  .notification-icon-circle {
    position: absolute;
    font-size: 9px !important;
    right: 2px;
    top: -4px;
  }
  .profile-icon {
    display: inline-block;
    width: 30px;
    height: 30px;
    text-align: center;
    border-radius: 50%;
    padding-top: 9px;
    overflow: hidden;
    -webkit-box-shadow: 0px 0px 15px 0px rgba(23,37,48,0.05);
    -moz-box-shadow: 0px 0px 15px 0px rgba(23,37,48,0.05);
    box-shadow: 0px 0px 15px 0px rgba(23,37,48,0.05);
  }
  .customize-panel-wrapper .v-icon.v-icon {
    font-size: 12px;
  }
  .v-expansion-panel {
    margin-top: 10px !important;
  }
  .customize-panel-wrapper .v-expansion-panel-header {
    font-size: 12px;
    padding: 10px;
    min-height: auto;
  }
  .customize-panel-bigger .v-expansion-panel-header {
    padding: 15px 10px;
  }
  .customize-panel-wrapper .v-expansion-panel--active .v-expansion-panel-header {
    min-height: auto;
  }
  .v-expansion-panels {
    border-radius: 7px !important;
  }
  .v-expansion-panel-content__wrap {
    padding: 0 15px 15px !important;
  }
  .v-expansion-panel::before {
    -webkit-box-shadow: 0px 0px 15px 0px rgba(23,37,48,0.05) !important;
    -moz-box-shadow: 0px 0px 15px 0px rgba(23,37,48,0.05) !important;
    box-shadow: 0px 0px 15px 0px rgba(23,37,48,0.05) !important;
  }
  .v-expansion-panels:not(.v-expansion-panels--accordion) > .v-expansion-panel--active {
    border-radius: 7px !important;
    overflow: hidden;
  }
  .theme--light.v-expansion-panels .v-expansion-panel-header .v-expansion-panel-header__icon .v-icon {
    color: #cecece !important;
  }
  .dashboard-header-wrapper .col {
    padding-top: 0 !important;
    max-width: 300px !important;
  }
  .dashboard-footer-wrapper {
    background-color: #fff !important;
    position: fixed !important;
    bottom: 0;
    width: 100%;
    padding: 15px !important;
  }
  .dashboard-footer-wrapper span, h1 {
    display: block;
    width: 100%;
  }
  .header-btn {
    font-size: 10px !important;
    padding: 5px 10px !important;
    height: 22px !important;
  }
  .date-covered-container {
    margin-top: -15px;
  }

  /* Sidenav */
  .v-application p {
    margin-bottom: 3px !important;
  }
  .profile-img {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    background-image: url(assets/user.svg);
  }
  .sidenav-footer {
    position: absolute;
    bottom: 0;
    border-top: 1px solid #DEDEDE;
  }

  /* Withdrawal */
  .gateway-wrapper .col {
    padding: 0 12px !important;
  }
  .v-messages__message {
    font-size: 10px;
  }
  .v-input__slot {
    margin-bottom: 3px;
  }
  .gateway-inner-wrapper .v-input__control {
    margin-bottom: 5px;
  }
  .gateway-inner-wrapper .col {
    padding: 0 !important;
  }
  .gateway-inner-wrapper .v-input__slot {
    min-height: 40px !important;
  }
  .gateway-inner-wrapper input {
    font-size: 14px;
  }
  .gateway-inner-wrapper .v-label {
    font-size: 12px;
  }
  .gateway-inner-wrapper .v-text-field--outlined .v-label {
    top: auto;
    background-color: #fff;
    padding: 0 5px;
  }
  .gateway-inner-wrapper .v-label--active {
    top: 16px !important;
  }
  .gateway-inner-wrapper .v-input__slot {
    margin-bottom: 0 !important
  }
  .gateway-inner-wrapper .v-text-field.v-text-field--enclosed .v-text-field__details {
    margin-bottom: 0;
  }
  .gateway-inner-wrapper .v-text-field__suffix {
    font-size: 12px;
    height: 100%;
    color: #fff;
    margin-right: -12px;
    padding: 10px !important;
    border-radius: 0 5px 5px 0;
  }
  .gateway-usdttrc20 .v-text-field__suffix {
    background: linear-gradient(to right, #C1272D, #C13A44);
  }
  .gateway-usdterc20 .v-text-field__suffix {
    background: linear-gradient(to right, #627FEB, #627FEB);
  }
  .gateway-bitcoin .v-text-field__suffix {
    background: linear-gradient(to right, #F7931A, #F7A43F);
  }
  .gateway-skrill .v-text-field__suffix {
    background: linear-gradient(to right, #862165, #AD4D8D);
  }
  .gateway-neteller .v-text-field__suffix {
    background: linear-gradient(to right, #83BA3B, #99C65D);
  }
  .usdttrc20-logo { width: 110px; }
  .usdterc20-logo { width: 110px; }
  .btc-logo { width: 90px; }
  .skrill-logo { width: 63px; }
  .neteller-logo { width: 90px; }
  .verification-wrapper {
    display: block;
    width: 100%;
  }
  .withdrawal-body-wrapper .v-expansion-panel-header__icon {
      display: none !important;
    }

  /* Transaction History */
  .bottom-sheet-container .theme--light.v-chip:not(.v-chip--active) {
    background: #fff !important;
  }
  .bottom-sheet-container .v-chip-group .v-chip {
    margin: 0px 5px 5px 0;
  }
  .transaction-filter-date .v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: 40px;
  }
  .transaction-filter-date .v-text-field--outlined .v-label {
    top: 10px;
    font-size: 14px;
  }
  .transaction-filter-date .v-text-field.v-text-field--enclosed .v-input__prepend-inner {
    margin-top: 8px;
  }
  .transaction-filter-date .theme--light.v-icon {
    color: #89B8FA;
    font-size: 20px;
  }
  .transaction-filter-date .v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot {
    padding: 0 8px;
  }
  .transaction-filter-date .v-text-field__slot {
    font-size: 14px;
  }
  .transaction-filter-date .v-text-field.v-text-field--enclosed .v-text-field__details {
    margin-bottom: 0;
  }
  .transaction-filter-date label.v-label.v-label--active.theme--light {
    top: 17px;
    left: -24px !important;
  }
  .transaction-filter-date .v-input__slot {
    margin-bottom: 0;
  }
  .transaction-filter-date .p-l-0 {
    padding-left: 0;
  }
  .transaction-filter-date .ghost-btn {
    border: 1px solid transparent;
    background-color: rgba(255, 255, 255, 0.2) !important;
    color: #fff;
    font-size: 12px !important;
  }
  .input-header-wrapper .v-text-field.v-text-field--solo .v-input__control {
    min-height: 35px;
  }
  .input-header-wrapper label.v-label.theme--light {
    font-size: 14px;
  }
  .input-header-wrapper .v-text-field.v-text-field--enclosed .v-input__prepend-inner {
    margin-top: 0;
  }
  .input-header-wrapper .theme--light.v-icon {
    color: #cecece;
    font-size: 18px;
  }
  .chip-active {
    color: #539AFB !important;
    border: 1px solid #539AFB !important;
  }
  .total-statement-wrapper .col {
    padding-top: 0 !important;
    padding-bottom: 3px !important;
  }
  .v-btn--rounded {
    border-radius: 5px;
  }
  .overflow-hidden.bg-gray-d.v-card.v-sheet.theme--light {
    height: 100%;
  }
  .language-flag {
    border: 2px solid #DEDEDE;
    border-radius: 5px;
    padding: 10px 10px 5px 10px;
    width: 25%;
  }
  .active-language {
    border: 2px solid #FBCC04;
  }
  .modal-img {
    margin-left: auto;
    margin-right: auto;
  }
  aside.v-navigation-drawer.v-navigation-drawer--absolute.v-navigation-drawer--is-mobile.v-navigation-drawer--open.v-navigation-drawer--temporary.theme--light {
    height: 100vh !important;
    position: fixed;
  }

  /* Desktop */
  .desktop-view {
    display: none;
  }
  .desktop-header-wrapper {
    position: fixed;
    width: 100%;
    padding: 10px 20px;
    z-index: 2000;
    height: 92px;
  }
  .desktop-header-inner {
    height: 72px;
  }
  .desktop-header-wrapper .notification-icon .fa-bell {
    font-size: 18px;
  }
  .desktop-header-wrapper .notification-icon-circle {
    top: -2px;
  }
  .desktop-header-wrapper .v-list-item__title {
    font-size: 14px;
  }
  .balance-avatar {
    background-color: rgba(255, 255, 255, 0.1);
  }
  .balance-divider {
    border-left: 1px solid rgba(255, 255, 255, 0.1);
  }
  .dashboard-total-wrapper {
    position: fixed;
    padding: 20px 5% 15px 10%;
    bottom: 0;
    left: 0;
    width: 100%;
    -webkit-box-shadow: 0px 0px 15px 0px rgba(23,37,48,0.10);
    -moz-box-shadow: 0px 0px 15px 0px rgba(23,37,48,0.10);
    box-shadow: 0px 0px 15px 0px rgba(23,37,48,0.10);
  }
  .dashboard-total-wrapper .v-btn__content {
    font-weight: 700;
    padding: 10px 20px;
  }
  .desktop-language {
    width: 85px;
    height: 35px;
    display: flex;
  }
  .desktop-language .v-text-field__details {
    display: none;
  }
  .desktop-language .v-text-field {
    padding-top: 0;
    margin-top: 0;
  }
  .desktop-language .v-icon.v-icon {
    font-size: 14px;
  }
  .desktop-language .v-select__selection {
    font-size: 12px;
  }
  .desktop-header-details {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .desktop-sidenav {
    position: fixed;
    z-index: 1000;
    top: 90px;
  }
  .desktop-sidenav .theme--light.v-navigation-drawer {
    background: linear-gradient(to right, #539AFB, #89B8FA);
  }
  .desktop-sidenav .v-navigation-drawer__content {
    height: 100vh;
  }
  .desktop-sidenav .theme--light.v-sheet {
    background-color: transparent !important;
  }
  .desktop-sidenav .v-card > *:last-child:not(.v-btn):not(.v-chip) {
    border-radius: 0;
  }
  .desktop-sidenav .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
      color: #fff !important;
  }
  .desktop-sidenav .v-list-item--dense .v-list-item__icon, .v-list--dense .v-list-item .v-list-item__icon {
    margin-top: 15px !important;
    margin-bottom: 15px !important;
  }
  .fixed-sidenav-wrapper {
    width: 330px;
    height: 100vh;
    position: fixed;
    top: 0;
    z-index: 1000;
    background-color: #fff;
    -webkit-box-shadow: 0px 0px 15px 0px rgba(23,37,48,0.05) !important;
    -moz-box-shadow: 0px 0px 15px 0px rgba(23,37,48,0.05) !important;
    box-shadow: 0px 0px 15px 0px rgba(23,37,48,0.05) !important;
  }
  .fixed-sidenav-wrapper .gradient-blue {
    padding: 40px 20px 60px;
  }
  .fixed-sidenav-wrapper .profile-img {
    width: 75px;
    height: 75px;
  }
  .fixed-sidenav-wrapper .profile-img .font-xxl {
      font-size: 30px;
  }
  .fixed-sidenav-wrapper .balance-container {
    margin: -30px 15px 0 15px;
    display: flex;
  }
  .fixed-sidenav-wrapper .balance-container div {
    width: 50%;
    padding: 15px 0;
  }
  .fixed-sidenav-wrapper .balance-container div:nth-child(1) {
    margin-right: 10px;
  }
  .fixed-sidenav-wrapper .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: transparent;
    text-transform: unset;
    font-weight: 600 !important;
    font-size: 14px !important;
    justify-content: flex-start;
  }
  .desktop-content-wrapper {
    padding-left: 375px !important;
    margin-top: 65px;
  }
  .v-dialog {
    box-shadow: none !important;
    width: 100%;
  }
  .export-btn {
    display: inline-block;
    height: 35px;
    min-width: 64px;
    padding: 10px 17px 0px 17px;
    font-size: 12px !important;
    font-weight: 700 !important;
    border-radius: 4px;
    cursor: pointer;
  }
  .ipad-view {
    display: none;
  }
  .no-record {
    padding: 50px 0;
  }
  .no-record img {
    width: 40%;
  }

  .banner-body .v-text-field--outlined > .v-input__control > .v-input__slot, .banner-body .v-text-field--outlined .v-input__control, .banner-body .v-select__slot {
    min-height: 40px;
  }
  .banner-body .v-select__selections {
    padding: 0 !important;
  }
  .banner-body .v-text-field.v-text-field--enclosed .v-input__append-inner {
    margin-top: 8px;
  }
  .website-validation {
    font-size: 10px !important;
    position: absolute;
    top: -22px;
    left: 12px;
  }

  /* Responsive */
    @media only screen and (min-width: 768px) {
    .desktop-body-wrapper {
      margin: 0 5% 0 15%;
    }
    .body-wrapper {
      margin: 0 5% 0 15%;
    }
    .mobile-view {
      display: none !important;
    }
    .ipad-view {
      display: inherit !important;
    }
    .desktop-view {
      display: inherit;
    }
    .login-bg {
      background-size: 100%;
    }
    .login-tab-wrapper {
      padding: 0 100px;
    }
    .login-header h1 {
      font-size: 30px;
    }
    .login-header p {
      font-size: 16px;
    }
    .login-logo {
      width: 22%;
    }
    .custom-card-shadow {
      border-radius: 15px !important;
      overflow: hidden;
    }
    .v-expansion-panels {
      border-radius: 15px !important;
    }
    .v-expansion-panels:not(.v-expansion-panels--accordion) > .v-expansion-panel--active {
      border-radius: 15px !important;
    }
    .gateway-wrapper .col {
      padding: 0 20px !important;
      font-size: 14px;
      line-height: 1.3;
    }
    .gateway-inner-wrapper {
      font-size: 14px;
    }
    .withdrawal-summary-container {
      width: 97%;
      margin-left: 10px;
      margin-top: 20px;
    }
    .withdrawal-summary-container .font-sm {
      font-size: 14px;
    }
    .withdrawal-form-container {
      margin: 30px 10px 0 10px;
    }
    .withdrawal-form-container .v-input {
      width: 48%;
    }
    .withdrawal-form-container .v-input:nth-child(odd) {
      margin-right: 10px !important;
    }
    .withdrawal-form-container .v-input input {
      max-height: 40px;
      height: 40px;
    }
    .gateway-inner-wrapper .v-text-field__suffix {
      font-size: 14px;
      /* padding: 14px 15px !important; */
      height: 40px;
    }
    .verification-wrapper {
      width: 49%;
    }
    .verification-wrapper .get-code-btn {
      height: 40px !important;
      font-size: 14px !important;
      margin-left: -10px;
    }
    .request-btn-wrapper .request-btn {
      max-width: 200px !important;
      min-width: 200px !important;
      width: 200px;
      margin: 10px;
    }
    .usdttrc20-logo { width: 150px; }
    .usdterc20-logo { width: 150px; }
    .btc-logo { width: 120px; }
    .skrill-logo { width: 85px; }
    .neteller-logo { width: 120px; }
    .gateway-inner-wrapper .v-text-field--outlined .v-label {
      font-size: 14px;
    }
    .no-record img {
      width: 25%;
    }
    .filter-ipad {
      margin-left: 40px;
    }
  }
  @media only screen and (min-width: 960px) {
    .container {
      max-width: 100% !important;
    }
  }
  @media only screen and (min-width: 1024px) {
    .desktop-body-wrapper {
      margin: 0 5% 0 13%;
    }
    .body-wrapper {
      margin: 0 5% 0 13%;
    }
    .ipad-view {
      display: none !important;
    }
    .login-tab-wrapper {
      padding: 0 0;
    }
  }
  @media only screen and (min-width: 1030px) {
    .desktop-body-wrapper {
      margin: 0 5% 0 10%;
    }
    .body-wrapper {
      margin: 0 5% 0 10%;
    }
    .login-tab-wrapper {
      padding: 0 130px;
    }
    .withdrawal-summary-container {
      width: 46%;
    }
    .withdrawal-form-container .v-input:nth-child(odd) {
      margin-right: 20px !important;
    }
  }
  @media (min-width: 1264px) {
    .container {
      max-width: 100% !important;
    }
    .login-tab-wrapper {
      padding: 0 70px;
    }
    .no-record img {
      width: 12%;
    }
  }
  @media (min-width: 1903px) {
    .login-tab-wrapper {
      padding: 0 130px;
    }
  }
</style>